export default __webpack_public_path__ + "static/media/Instagram_Glyph_White.png";